function Products(): JSX.Element {
  return (
    <div>
      <h1>Products Page</h1>
      <p>This is the products page.</p>
    </div>
  );
}
export default Products;
